import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useLoggedInUser } from "@src/api/user-auths/login";
import { useCheckSubscriptionStatus } from "@src/components/LimitAccess/check-subscriptions-hooks";
import { useMixpanelLogin } from "@src/hooks/mixpanel";
import {
  resetExperienceListFilters,
  resetPersonalizationListFilters,
} from "@src/store/slices/appSettings";

import { SubscribedRoutes } from "./subscribedRoutes";

export const LoggedInRoutes = () => {
  useLoggedInUser();
  useGetOrganizationSummary();
  const dispatch = useDispatch();
  useMixpanelLogin();

  useIsAdmin();
  useCheckSubscriptionStatus(true);

  useEffect(() => {
    dispatch(resetPersonalizationListFilters());
    dispatch(resetExperienceListFilters());
  }, []);

  return <SubscribedRoutes />;
};
